import i18next from "i18next";
import { html } from "lit-html";
import { unsafeHTML } from "lit-html/directives/unsafe-html";
export function Contact() {
  return html`
		<div class="py-2 mx-auto max-w-5xl">
			<h1 class="text-2xl mt-12 mb-8 font-bold">${i18next.t("Contact")}</h1>
			${ClientContext.CompanyInformation.Companies.length === 0 ? html`
						<p class="mb-6 text-red-500 font-bold">
							${i18next.t(
    "Please note that no companies have been allocated to your account. Please use the below contact information to help us solve this issue as quickly as possible. Thank you!"
  )}
						</p>
				  ` : ""}
			<p class="mb-6 text-brand-primary font-bold">
				${unsafeHTML(
    i18next.t(
      "contacts_message",
      "For specific questions, please write to {{- link_start}}{{- contactEmail}}{{- link_end}} or contact your Client Manager directly at their phone number (between 9:00 and 17:00 Central European Time).",
      {
        link_start: `<a class="underline" href="mailto:${ClientContext.ContactEmailAddress}">`,
        contactEmail: ClientContext.ContactEmailAddress,
        link_end: "</a>"
      }
    )
  )}
			</p>
			<p class="mt-6 text-brand-primary font-bold">${i18next.t("We look forward to helping you.")}</p>
		</div>
	`;
}
